module.exports = __webpack_public_path__ + "img/player.80dc2789.png";